import { container } from 'tsyringe';
import { FormTemplateRepository } from 'packages/form/entities/legacy/FormTemplateRepository';
import { types } from './mutations';
export var actions = {
    getTemplate: function (_a, uuid) {
        var commit = _a.commit;
        commit(types.FORM_TEMPLATE_RETRIEVING);
        return container.resolve(FormTemplateRepository).getTemplate(uuid).then(function (template) {
            commit(types.FORM_TEMPLATE_RETRIEVED, { formTemplate: template });
        });
    },
};
